var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClassName("approva-rail") }, [
    _c("ul", { class: _vm.getClassName("approva-rail__items") }, [
      _c("li", { class: _vm.getClassName("approva-rail__item") }, [
        _c("div", { class: _vm.getClassName("approva-rail__title") }, [
          _c("span", { staticClass: "purchase__counter" }, [_vm._v("※")]),
          _vm._v(
            "1 本 1 本手作業でお作りしているため、色ムラや個体差がある場合ございます。\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("approva-rail__content__wrap") }, [
          _c(
            "label",
            {
              class: [].concat(
                _vm.getClassNameActive(
                  "approva-rail__action",
                  this.curtainrail_approval_1,
                  _vm.value.curtainrail_approval_1
                )
              ),
              attrs: { for: "curtainrail-approval-1" }
            },
            [
              _c("div", { class: _vm.getClassName("approva-rail__content") }, [
                _vm._v("\n            承認しました\n          ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { type: "radio", id: "curtainrail-approval-1" },
                domProps: { value: 1, checked: _vm._q(_vm.internalValue, 1) },
                on: {
                  change: function($event) {
                    _vm.internalValue = 1
                  }
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { class: _vm.getClassName("approva-rail__item") }, [
        _c("div", { class: _vm.getClassName("approva-rail__title") }, [
          _c("span", { staticClass: "purchase__counter" }, [_vm._v("※")]),
          _vm._v(
            "幅 150㎝ 以上のレールは、耐久性の観点から壁との接着部分（ブラケット）が付属します。\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("approva-rail__content__wrap") }, [
          _c(
            "label",
            {
              class: [].concat(
                _vm.getClassNameActive(
                  "approva-rail__action",
                  this.curtainrail_approval_2,
                  _vm.value.curtainrail_approval_2
                )
              ),
              attrs: { for: "curtainrail-approval-2" }
            },
            [
              _c("div", { class: _vm.getClassName("approva-rail__content") }, [
                _vm._v("\n            承認しました\n          ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { type: "radio", id: "curtainrail-approval-2" },
                domProps: { value: 2, checked: _vm._q(_vm.internalValue, 2) },
                on: {
                  change: function($event) {
                    _vm.internalValue = 2
                  }
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { class: _vm.getClassName("approva-rail__item") }, [
        _c("div", { class: _vm.getClassName("approva-rail__title") }, [
          _c("span", { staticClass: "purchase__counter" }, [_vm._v("※")]),
          _vm._v("取り付けの際は下地を必ずご確認下さい。\n      ")
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("approva-rail__content__wrap") }, [
          _c(
            "label",
            {
              class: [].concat(
                _vm.getClassNameActive(
                  "approva-rail__action",
                  this.curtainrail_approval_3,
                  _vm.value.curtainrail_approval_3
                )
              ),
              attrs: { for: "curtainrail-approval-3" }
            },
            [
              _c("div", { class: _vm.getClassName("approva-rail__content") }, [
                _vm._v("\n            承認しました\n          ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { type: "radio", id: "curtainrail-approval-3" },
                domProps: { value: 3, checked: _vm._q(_vm.internalValue, 3) },
                on: {
                  change: function($event) {
                    _vm.internalValue = 3
                  }
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { class: _vm.getClassName("approva-rail__item") }, [
        _c("div", { class: _vm.getClassName("approva-rail__title") }, [
          _c("span", { staticClass: "purchase__counter" }, [_vm._v("※")]),
          _vm._v(
            "サイズにつきましては全てビス穴からビス穴までの長さとなっております。（両端 1cm ずつゆとりを持たせてご注文ください）\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("approva-rail__content__wrap") }, [
          _c(
            "label",
            {
              class: [].concat(
                _vm.getClassNameActive(
                  "approva-rail__action",
                  this.curtainrail_approval_4,
                  _vm.value.curtainrail_approval_4
                )
              ),
              attrs: { for: "curtainrail-approval-4" }
            },
            [
              _c("div", { class: _vm.getClassName("approva-rail__content") }, [
                _vm._v("\n            承認しました\n          ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { type: "radio", id: "curtainrail-approval-4" },
                domProps: { value: 4, checked: _vm._q(_vm.internalValue, 4) },
                on: {
                  change: function($event) {
                    _vm.internalValue = 4
                  }
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { class: _vm.getClassName("approva-rail__item") }, [
        _c("div", { class: _vm.getClassName("approva-rail__title") }, [
          _c("span", { staticClass: "purchase__counter" }, [_vm._v("※")]),
          _vm._v(
            "商品をカートに入れた後、ご購入手続き画面の「備考」欄にご希望のサイズをご記入ください。\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("approva-rail__content__wrap") }, [
          _c(
            "label",
            {
              class: [].concat(
                _vm.getClassNameActive(
                  "approva-rail__action",
                  this.curtainrail_approval_5,
                  _vm.value.curtainrail_approval_5
                )
              ),
              attrs: { for: "curtainrail-approval-5" }
            },
            [
              _c("div", { class: _vm.getClassName("approva-rail__content") }, [
                _vm._v("\n            承認しました\n          ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { type: "radio", id: "curtainrail-approval-5" },
                domProps: { value: 5, checked: _vm._q(_vm.internalValue, 5) },
                on: {
                  change: function($event) {
                    _vm.internalValue = 5
                  }
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { class: _vm.getClassName("approva-rail__item") }, [
        _c("div", { class: _vm.getClassName("approva-rail__title") }, [
          _c("span", { staticClass: "purchase__counter" }, [_vm._v("※")]),
          _vm._v(
            "オーダーに関しましては、受注から納品まで２～３週間いただいております。\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("approva-rail__content__wrap") }, [
          _c(
            "label",
            {
              class: [].concat(
                _vm.getClassNameActive(
                  "approva-rail__action",
                  this.curtainrail_approval_6,
                  _vm.value.curtainrail_approval_6
                )
              ),
              attrs: { for: "curtainrail-approval-6" }
            },
            [
              _c("div", { class: _vm.getClassName("approva-rail__content") }, [
                _vm._v("\n            承認しました\n          ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { type: "radio", id: "curtainrail-approval-6" },
                domProps: { value: 6, checked: _vm._q(_vm.internalValue, 6) },
                on: {
                  change: function($event) {
                    _vm.internalValue = 6
                  }
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { class: _vm.getClassName("approva-rail__item") }, [
        _c("div", { class: _vm.getClassName("approva-rail__title") }, [
          _c("span", { staticClass: "purchase__counter" }, [_vm._v("※")]),
          _vm._v("お客様都合によるご注文後のキャンセルは承りません。\n      ")
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("approva-rail__content__wrap") }, [
          _c(
            "label",
            {
              class: [].concat(
                _vm.getClassNameActive(
                  "approva-rail__action",
                  this.curtainrail_approval_7,
                  _vm.value.curtainrail_approval_7
                )
              ),
              attrs: { for: "curtainrail-approval-7" }
            },
            [
              _c("div", { class: _vm.getClassName("approva-rail__content") }, [
                _vm._v("\n            承認しました\n          ")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { type: "radio", id: "curtainrail-approval-7" },
                domProps: { value: 7, checked: _vm._q(_vm.internalValue, 7) },
                on: {
                  change: function($event) {
                    _vm.internalValue = 7
                  }
                }
              })
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }